import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { EventEmitter } from 'events';
import { bindActionCreators } from 'redux';
import { compose, withHandlers, lifecycle } from 'recompose';

import { getRoleIdType } from '../../../../auth/selectors';
import {
  fetchOwnerCustomerAppointments,
  getAppointment,
  clearCustomerAppointments,
} from '../../actions';
import AppointmentsList from '../../../appointments/appointmentsList';
import withNotifications from '../../../../common/withNotifications';
import withActiveUserIdAndType from '../../../../common/hoc/withActiveUserIdAndType';

const AppointmentsListContainer = compose(
  withActiveUserIdAndType(),
  withRouter,
  withNotifications,
  connect(
    (state, ownProps) => ({
      type: 'customer',
      appointments: state.customers.customerAppointments,
      shopOrBarber: getRoleIdType(state),
      customerId: ownProps.params.customerId,
    }),
    dispatch => ({
      fetchAppointments: bindActionCreators(fetchOwnerCustomerAppointments, dispatch),
      fetchAppointment: bindActionCreators(getAppointment, dispatch),
      clearCustomerAppointments: bindActionCreators(clearCustomerAppointments, dispatch),
    })
  ),
  withHandlers({
    fetchAppointments: props => () =>
      props.fetchAppointments(props.activeId, props.activeType, props.customerId),
  }),
  lifecycle({
    componentDidMount() {
      EventEmitter.prototype.on('appointment-saved', this.props.fetchAppointments);
      this.props.clearCustomerAppointments();
      this.props.fetchAppointments();
    },
    componentWillUnmount() {
      EventEmitter.prototype.removeListener('appointment-saved', this.props.fetchAppointments);
    },
  }),
)(AppointmentsList);

export default AppointmentsListContainer;
